import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPrivate from 'config/axiosPrivate';

export const fetchClientList = createAsyncThunk(
  'adminClientList/fetchClientList',
  async (arg, thunkAPI) => {
    try {
      const response = await axiosPrivate.get('/commands/website/all');
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
